import { sizer } from "layout/styles/styled/sizer";
import { Card } from "primereact/card";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  margin-bottom: ${sizer(4)};
`;
